import { Navbar } from "./Navbar";
import { Footer } from "../layout/Footer";
import { Header } from "../layout/Header";
import { Outlet, useLocation } from "react-router-dom";

export const Layout = () => {
  const { pathname } = useLocation();
  const path = pathname.toLowerCase();

  const shouldHideFooter = [
    "/login",
    "/myregistration",
    "/verify",
    "/register",
  ].includes(path);
  const shouldHideNavbar = false;

  return (
    <div className="flex flex-col min-h-screen">
      {!shouldHideNavbar && (
        <div className="z-[1000] w-full flex justify-center">
          <Navbar />
        </div>
      )}

      <div className="z-[999] w-full flex justify-center">
        <Header />
      </div>

      <main className="flex-grow">
        <Outlet />
      </main>

      {!shouldHideFooter && (
        <div className="w-full">
          <Footer />
        </div>
      )}
    </div>
  );
};
